var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilesClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Shadow_3",
    x: 18.5,
    y: 16.5,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c2c2c2",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Shadow_2",
    x: 9.5,
    y: 6.5,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c2c2c2",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Shadow_1",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c2c2c2",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28573",
    "data-name": "Group 28573",
    transform: "translate(1908.5 3833.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27593",
    "data-name": "Group 27593",
    transform: "translate(-1591 -5401.902)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -317.5, 1568.5)",
    filter: "url(#Shadow_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow_3-2",
    "data-name": "Shadow 3",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(24.5 20.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -317.5, 1568.5)",
    filter: "url(#Shadow_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow_2-2",
    "data-name": "Shadow 2",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(24.5 20.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -317.5, 1568.5)",
    filter: "url(#Shadow_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow_1-2",
    "data-name": "Shadow 1",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(24.5 20.5)",
    fill: "#fff",
    stroke: "#dedede",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27403",
    "data-name": "Group 27403",
    transform: "translate(-293 1589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37445",
    "data-name": "Path 37445",
    d: "M628.078,472.079a28,28,0,1,0,28,28A28,28,0,0,0,628.078,472.079Z",
    transform: "translate(-600.079 -472.079)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27588",
    "data-name": "Group 27588",
    transform: "translate(-1519.417 -4229.53) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    y2: 20,
    transform: "translate(76.5 542.5)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    y2: 20,
    transform: "translate(86.5 552.5) rotate(90)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilesClose);
export default __webpack_public_path__ + "static/media/miles-close.48efe8367ee89ce108024db8e3293b32.svg";
export { ForwardRef as ReactComponent };